import { create } from 'zustand';
import { ApiUtils, type CountryEntity, MiscApi, RequestStrategyEnum } from '@shared/api';

interface UseCountriesStore {
  loading: boolean;
  data: CountryEntity[];
  error: string | null;
  getCountries: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCountriesStore = create<UseCountriesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getCountries: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getCountries(signal);
      set({ loading: false, data: result?.filter((country) => Boolean(country.code)) || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
